import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOU_DECIDE: "Du bestemmer",
      PAUSE_OR_STOP: "Pause eller avslutt når du vil",
      GO_FORWARD: "Gå videre",
    },
    se: {
      YOU_DECIDE: "Du bestämmer",
      PAUSE_OR_STOP: "Pausa eller avsluta när du vill",
      GO_FORWARD: "Gå vidare",
    },
    dk: {
      YOU_DECIDE: "Du bestemmer",
      PAUSE_OR_STOP: "Sæt på pause eller stop, når du vil",
      GO_FORWARD: "Gå videre",
    },
  } as const
)[language];
